import React, { forwardRef } from "react";
import { Typography } from "@mui/material";

export const FormatPostContent = forwardRef(({ content, TypographyProps = {}, ...props }, ref) => {
  if (!content) return null;

  let displayContent = content;
  try {
    const parsed = JSON.parse(content);
    if (Array.isArray(parsed) && parsed.length > 0 && parsed[0].id && parsed[0].id.startsWith('var_')) {
      displayContent = parsed[0].content || "";
    }
  } catch (e) {
    // Not valid JSON, fallback to original content
  }

  // Split by @[Name] and #Hashtag
  // Regex explanation:
  // @\[(.*?)\] captures mentions
  // (#\w+) captures hashtags
  // (https?:\/\/[^\s]+) captures URLs
  const regex = /(@\[.*?\]|#\w+|https?:\/\/[^\s]+)/g;
  
  const parts = displayContent.split(regex);

  return (
    <Typography ref={ref} {...TypographyProps} {...props}>
      {parts.map((part, index) => {
        if (part.startsWith("@[") && part.endsWith("]")) {
          const mentionName = part.substring(2, part.length - 1);
          return (
            <span key={index} style={{ color: "#2D76DC", fontWeight: 600 }}>
              {mentionName}
            </span>
          );
        } else if (part.startsWith("#")) {
          return (
            <span key={index} style={{ color: "#2D76DC", fontWeight: 600 }}>
              {part}
            </span>
          );
        } else if (part.startsWith("http://") || part.startsWith("https://")) {
          return (
            <span key={index} style={{ color: "#2D76DC", fontWeight: 600 }}>
              {part}
            </span>
          );
        }
        
        // Render regular text, allowing parent Typography to handle white-space
        return (
          <span key={index}>
            {part}
          </span>
        );
      })}
    </Typography>
  );
});
